"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_cloud__upload__storage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "5fe60dc6-2257-4e6d-a444-2038bbdffed6",
    x1: 85.17,
    y1: 84.92,
    x2: 135.43,
    y2: 135.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "cloud-upload-hi"), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "83026d14-365f-4016-88a6-e3f243d660cf",
    "data-name": "cloud-upload-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "51e70b4a-0464-4994-add5-1bba7f434a9a",
    "data-name": "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176,85.25a38.91,38.91,0,0,0-48.64-37.51A45.17,45.17,0,0,0,39.3,56.46,34.74,34.74,0,0,0,50.86,124h86.52A38.81,38.81,0,0,0,176,85.25Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.38,122H50.86A34.8,34.8,0,0,1,16,88.13c0,.37,0,.74,0,1.12A34.8,34.8,0,0,0,50.86,124h86.52A38.81,38.81,0,0,0,176,85.25c0-.33,0-.67,0-1A38.8,38.8,0,0,1,137.38,122Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,72.13l.58,36.42L98.69,124h38.69a39,39,0,0,0,10.83-1.61Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#5fe60dc6-2257-4e6d-a444-2038bbdffed6)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 172.02,
    x2: 96,
    y2: 74.02,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "70 102.02 96 74.02 122 102.02",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12,
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,174a4,4,0,0,1-4-4v2a4,4,0,1,0,8,0v-2A4,4,0,0,1,96,174Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.93,102.74a4,4,0,0,1-6.79-1.7,4,4,0,0,0,6.79,3.7L92,84.21v-2Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.72,103a4,4,0,0,1-5.65-.21L100,82.21v2l19.07,20.54a4,4,0,0,0,6.79-3.7A4,4,0,0,1,124.72,103Z",
    transform: "translate(0 0)"
  }))))));
}

var _default = ic_cloud__upload__storage;
exports.default = _default;